module.exports = __webpack_public_path__ + "static/thumb_houses-32799a2826c3a4905ba5fdcc887f5671.jpg";